import "../../App.css"
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { FaSearch } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import { useContext, useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { SymbolInfoContext } from '../../context/SymbolContext';
import { FetchInstrument } from "../../config/Api";
function SymbolModals({ boolData, Fun }) {
    const [searchSymbol, setSearchSymbol] = useState("");
    const [filteredOptions, setFilteredOptions] = useState([]);
    const { TakeSymbolFuntion } = useContext(SymbolInfoContext);
    const [params] = useState(new URLSearchParams(window.location.search));
    const [options, setOptions] = useState(null)

    

    useEffect( () => {
        const params_userId = params.get("user_id");  
        const params_identifer = params.get("identifier");  
        async function InstrumentFetch(params_userId,params_identifer){
            const response = await FetchInstrument(params_userId,params_identifer);    //extra all instrument 
            const cleanedSymbols = response.map(item =>
                item.symbol.startsWith("#") ? item.symbol.substring(1) : item.symbol
            );
            setOptions(cleanedSymbols)
            return true
        }
        if (params_userId) {
             InstrumentFetch(params_userId,params_identifer)
        }
    }, []);

    const updateParam = (newSymbol) => {
        const newParams = new URLSearchParams(params);
        newParams.set('symbol', newSymbol);
        const newUrl = `${window.location.pathname}?${newParams.toString()}`;
        window.location.href = newUrl;
        return;
    };
    const handleSearchChange = (e) => {
        const query = e.target.value;
        setSearchSymbol(query);
        const filtered = options.filter((option) =>
            option.toLowerCase().includes(query.toLowerCase())
        );
        setFilteredOptions(filtered);
    };
    const handleSelectOption = (option) => {
        setSearchSymbol(option);
        setFilteredOptions([]);
    };
    const handleClick = () => {
        if (searchSymbol !== "") {
            TakeSymbolFuntion(searchSymbol)
            Fun()
            updateParam(searchSymbol)
            setSearchSymbol("")
        }
        else {
            toast.error("please select symbol")
        }
    }
    return (
        <>
            <Modal
                show={boolData}
                onHide={Fun}
                centered
                onClick={(e) => e.stopPropagation()}
                backdrop="static"
            >
                <Modal.Header closeButton className="bg-dark text-white">
                    <Modal.Title>Search Symbol</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark text-white">
                    <Form className='h-[280px] w-full'>
                        <Form.Group className="mb-3 mt-2" controlId="searchDropdown">
                            <Form.Label className='mb-3'>Search and Select</Form.Label>
                            <div className="position-relative">
                                <Form.Control
                                    type="text"
                                    placeholder="Search..."
                                    value={searchSymbol}
                                    onChange={handleSearchChange}
                                    autoFocus
                                    className="bg-dark text-white border-secondary search-input"
                                />
                                <div className="position-absolute" style={{ right: '10px', top: '10px' }}>
                                    <FaSearch color="#aaa" />
                                </div>
                                {searchSymbol && filteredOptions.length > 0 && (
                                    <Dropdown.Menu
                                        show
                                        className="position-absolute w-100 mt-1 bg-dark text-white border-secondary"
                                        style={{ maxHeight: '200px', overflowY: 'auto' }}
                                    >
                                        {filteredOptions.map((option, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleSelectOption(option);
                                                }}
                                                className="custom-dropdown-item text-white hover:bg-red-400"
                                            >
                                                {option}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                )}
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="bg-dark text-white font-sans">
                    <Button variant="secondary" onClick={Fun}>
                        Close
                    </Button>
                    <Button
                        className="text-white text-sm border-none btn-apply font-sans"
                        style={{ background: "#1a73ea9", border: "none", outline: "none" }}
                        onClick={handleClick}
                    >
                        Apply
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SymbolModals;
